import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { environment } from 'src/environments/environment'
import { PackageData, PackageFilter } from '../../models/package.model'
import { ActivationStatus } from 'src/app/shared/enums/general.enum'
import { PackageService } from '../../services/package.service'
import { Subscription } from 'rxjs'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { MatDialog } from '@angular/material/dialog'
import { ToastrService } from 'ngx-toastr'

@Component({
	selector: 'app-packages-table',
	templateUrl: './packages-table.component.html',
	styleUrls: ['./packages-table.component.scss'],
})
export class PackagesTableComponent implements OnInit {
	@Input() packages: PackageData[] = []
	@Input() packageFilter: PackageFilter = {
		paging: { pageNumber: 1, pageSize: 10 },
		branchId: 0,
		searchText: '',
	}
	@Input() totalCount = 0
	@Input() queryParams: any
	@Output() refreshData: EventEmitter<boolean> = new EventEmitter()
	imagePath = environment.attachmentPath
	isActiveEnum = ActivationStatus
	subscription = new Subscription()
	constructor(
		public translate: TranslateService,
		private packageServ: PackageService,
		private dialog: MatDialog,
		private toaster: ToastrService
	) {}

	ngOnInit(): void {}

	tackAction(packageData: PackageData, action: string, event: any) {
        action == 'ACTIVATE_PACKAGE'
            ? (event.source.checked = packageData.isActive)
            : (event.source.checked = packageData.canBook)
        this.dialog
            .open(ConfirmationMessageComponent, {
                width: '450px',
                data: {
                    notflex: true,
                    image: 'assets/images/correct.svg',
                    confirmBtnStyle: `bg-gradient text-white`,
                    cancelBtnStyle: ` border-[1px] border-secondry-color-Gray text-dark-grey border-solid`,
                    message: `CONFIRMATION_MESSAGE.${
                        action == 'ACTIVATE_PACKAGE'
                            ? 'ACTIVATE_PACKAGE'
                            : 'CLOSE_BOOKING_PACKAGE'
                    }`,
                    cancelBtn: 'ACTIONS.CANCEL',
                    confirmBtn: 'ACTIONS.YES',
                },
            })
            .afterClosed()
            .subscribe({
                next: (res) => {
                    if (res) {
                        this.subscription.add(
                            this.getApi(packageData, action).subscribe({
                                next: (res: any) => {
                                    if (res) {
                                        if (action == 'ACTIVATE_PACKAGE') {
                                            packageData['isActive'] = !event.source.checked
                                            !packageData['isActive']
                                                ? (packageData['canBook'] = false)
                                                : ''
                                        }
                                        if (action == 'CAN_BOOK') {
                                            packageData['canBook'] = !event.source.checked
                                        }
                                    }
                                    this.toaster.success(
                                        this.translate.instant('TOASTER.MSG_SUCCESS')
                                    )
                                },
                                error: (err: any) => {
                                    this.toaster.error(err?.error?.error?.message)
                                },
                            })
                        )
                    }
                },
            })
    }

	deletePackage(packageData: PackageData) {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '385px',
				data: {
					notflex: true,
					image: 'assets/images/block.svg',
					message: `${
						packageData?.hasBooking
							? 'CONFIRMATION_MESSAGE.DELETE_PAACKAGE_REJECTION'
							: 'CONFIRMATION_MESSAGE.DELETE_PAACKAGE'
					}`,
					cancelBtn: `${
						packageData?.hasBooking ? 'ACTIONS.OK' : 'ACTIONS.CANCEL'
					}`,
					confirmBtn: `${packageData?.hasBooking ? '' : 'ACTIONS.YES'}`,
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.subscription.add(
							this.packageServ.deletePackage(packageData.id).subscribe({
								next: (res: any) => {
									this.toaster.success(
										this.translate.instant('TOASTER.DELETED_SUSSESSFULLY')
									)
									this.refreshData.emit()
								},
								error: (err: any) => {
									this.toaster.error(err?.error?.error?.message)
								},
							})
						)
					}
				},
			})
	}

	getApi(packageData: PackageData, action: string) {
		return action == 'ACTIVATE_PACKAGE'
			? this.packageServ.activatePackage(
					packageData?.id,
					!packageData?.isActive
			  )
			: this.packageServ.canBookPackage(packageData?.id, !packageData?.canBook)
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
